<button
  class="button-primary"
  [class.size-small]="size === 'small'"
  [class.size-medium]="size === 'medium'"
  [class.size-large]="size === 'large'"
  type="button"
  [attr.type]="type"
  [disabled]="disabled"
  [attr.data-testid]="testId"
>
  <span>{{ label }}@if (labelSuffix) {<span translate="no" data-wg-notranslate> {{ labelSuffix }}</span>}</span>
</button>
